"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _solidAuthClient = _interopRequireDefault(require("solid-auth-client"));

var _queryLdflex = _interopRequireDefault(require("@solid/query-ldflex")); // Wildcard for tracking all resources


var ALL = '*'; // Subscribers per resource URL

var subscribers = {}; // WebSockets per host

var webSockets = {}; // All fetched URLs

var fetchedUrls = new Set();
/**
 * Notifies a subscriber of updates to resources on a Solid server,
 * by listening to its WebSockets.
 */

var UpdateTracker =
/*#__PURE__*/
function () {
  /** Create a tracker that sends updates to the given subscriber function. */
  function UpdateTracker(subscriber) {
    _classCallCheck(this, UpdateTracker);

    this.subscriber = subscriber;
  }
  /** Subscribes to changes in the given resources */


  _createClass(UpdateTracker, [{
    key: "subscribe",
    value: function subscribe() {
      for (var _len = arguments.length, urls = new Array(_len), _key = 0; _key < _len; _key++) {
        urls[_key] = arguments[_key];
      }

      for (var _i = 0, _urls = urls; _i < _urls.length; _i++) {
        var url = _urls[_i];
        // Create a new subscription to the resource if none existed
        url = url.replace(/#.*/, '');

        if (!(url in subscribers)) {
          subscribers[url] = new Set();
          if (url !== ALL) trackResource(url);else fetchedUrls.forEach(trackResource);
        } // Add the new subscriber


        subscribers[url].add(this.subscriber);
      }
    }
    /** Unsubscribes to changes in the given resources */

  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      for (var _len2 = arguments.length, urls = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        urls[_key2] = arguments[_key2];
      }

      for (var _i2 = 0, _urls2 = urls; _i2 < _urls2.length; _i2++) {
        var url = _urls2[_i2];
        url = url.replace(/#.*/, '');
        if (url in subscribers) subscribers[url].delete(this.subscriber);
      }
    }
  }]);

  return UpdateTracker;
}();
/** Tracks updates to the given resource */


exports.default = UpdateTracker;

function trackResource(url) {
  // Try to find an existing socket for the host
  var _ref = new URL(url),
      protocol = _ref.protocol,
      host = _ref.host;

  var webSocket = webSockets[host]; // If none exists, create a new one

  if (!webSocket) {
    var socketUrl = "".concat(protocol.replace('http', 'ws'), "//").concat(host, "/");
    webSockets[host] = webSocket = new WebSocket(socketUrl);
    Object.assign(webSocket, {
      enqueue: enqueue,
      onmessage: onmessage,
      ready: new Promise(function (resolve) {
        return webSocket.onopen = resolve;
      })
    });
  } // Subscribe to updates on the resource


  webSocket.enqueue("sub ".concat(url));
}
/** Enqueues data on the WebSocket */


function enqueue(_x) {
  return _enqueue.apply(this, arguments);
}
/** Processes an update message from the WebSocket */


function _enqueue() {
  _enqueue = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(data) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return this.ready;

          case 2:
            this.send(data);

          case 3:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _enqueue.apply(this, arguments);
}

function onmessage(_ref2) {
  var data = _ref2.data;
  // Verify the message is an update notification
  var match = /^pub +(.+)/.exec(data);
  if (!match) return; // Invalidate the cache for the resource

  var url = match[1];

  _queryLdflex.default.clearCache(url); // Notify the subscribers


  var update = {
    timestamp: new Date(),
    url: url
  };
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (subscribers[url] || [])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var subscriber = _step.value;
      subscriber(update);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = (subscribers[ALL] || [])[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var _subscriber = _step2.value;

      _subscriber(update);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
} // Keep track of all fetched resources


_solidAuthClient.default.on('request', function (url) {
  if (!fetchedUrls.has(url)) {
    if (ALL in subscribers) trackResource(url);
    fetchedUrls.add(url);
  }
});